'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function TKFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-1bswin0tk", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-k4jw7jvi4", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-1okynqmap" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-1okynqmap", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-1bswin0tk)" }, /* @__PURE__ */ React.createElement("use", { fill: "#2e42a5", xlinkHref: "#mantine-1okynqmap" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M3.294 10.063l-.885.548.344-.92L2 8.995h.913L3.294 8l.292.995H4.5l-.659.696.323.92zm4-4l-.885.548.344-.92L6 4.995h.913L7.294 4l.292.995H8.5l-.659.696.323.92zm4 4l-.885.548.344-.92L10 8.995h.913L11.294 8l.292.995h.914l-.659.696.323.92zm-4 4l-.885.548.344-.92L6 12.995h.913L7.294 12l.292.995H8.5l-.659.696.323.92z",
        mask: "url(#mantine-k4jw7jvi4)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M6.616 17.965l22.753.04.631.835-.63 1.16-22.754-.44-.306-.835zM24.842 5.463c-1.323 1.988-1.323 4.3 0 6.934 1.984 3.952 2.762 3.681 4.85 4.148H7.342c8.944-6.043 14.778-9.737 17.5-11.082z",
        mask: "url(#mantine-k4jw7jvi4)"
      }
    )))
  );
}

export { TKFlag };
//# sourceMappingURL=TK.mjs.map
